'use client';

import { ContentWrapper, LegalTextStack } from '@collab/atoms';
import { legalComponents } from 'components/mdxComponents/legalMdx';
import { MDXRemote, type MDXRemoteSerializeResult } from 'next-mdx-remote';
import type { FC } from 'react';

type MdxLegalPageProps = {
  mdxContent: MDXRemoteSerializeResult;
};

const MdxLegalPage: FC<MdxLegalPageProps> = ({ mdxContent }) => (
  <ContentWrapper>
    <LegalTextStack>
      <MDXRemote {...mdxContent} components={legalComponents} />
    </LegalTextStack>
  </ContentWrapper>
);

export default MdxLegalPage;
